"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFinalTransform = exports.getSVGwithColors = exports.intermediateToRenderer = void 0;
const fym_lib_1 = require("@faceyourmanga/fym-lib");
function intermediateToRenderer(resources, set, intermediates) {
    return intermediates.map(intermediate => {
        const svg = getSVGwithColors(resources, set, intermediate, intermediates);
        const transform = getFinalTransform(intermediate.transforms);
        return {
            svg,
            transform,
            masks: intermediate.masks,
            bounding: intermediate.bounding,
        };
    });
}
exports.intermediateToRenderer = intermediateToRenderer;
/**
 * Replace element svg with drawable color
 *
 * @param resources
 * @param set
 * @param drawable
 * @param drawables
 * @returns
 */
function getSVGwithColors(resources, set, intermediate, intermediates) {
    const elementId = intermediate.elementId;
    const element = resources.element[elementId];
    const elementCategoryForSet = resources.category[intermediate.categoryIdForSet];
    let svg = element.svg;
    if (typeof intermediate.colors !== 'undefined' && Object.keys(intermediate.colors).length > 0) {
        const elementHasntColorRef = fym_lib_1.getElementHasntColorRef(resources, elementId, set, intermediates);
        const drawableRealCategory = elementHasntColorRef
            ? elementCategoryForSet.dependsCategoryPalette
            : elementCategoryForSet.id;
        Object.entries(intermediate.colors || {}).forEach(([mappingPaletteId, colorId]) => {
            const colorsToReplace = fym_lib_1.sanitizeElementMappingForCategory(resources, elementId, mappingPaletteId, colorId, drawableRealCategory);
            colorsToReplace.forEach(([search, replace]) => {
                svg = svg.replace(new RegExp(search, 'ig'), replace);
            });
        });
    }
    if (typeof elementCategoryForSet.dependsCategoryPalette !== 'undefined') {
        // Controllo se l'elemento corrente dipende dal colore di un'altra categoria
        const categoryDependsPalette = elementCategoryForSet.dependsCategoryPalette;
        const elementThatHasDepends = intermediates.find(d => fym_lib_1.findCategoryOfElementForSet(resources, d.elementId, set) === categoryDependsPalette);
        if (elementThatHasDepends && elementThatHasDepends.colors) {
            Object.entries(elementThatHasDepends.colors).forEach(([mappingPaletteId, colorId]) => {
                const colorsToReplace = fym_lib_1.sanitizeElementMappingForCategory(resources, elementId, mappingPaletteId, colorId, categoryDependsPalette);
                colorsToReplace.forEach(([search, replace]) => {
                    svg = svg.replace(new RegExp(search, 'ig'), replace);
                });
            });
        }
    }
    return svg;
}
exports.getSVGwithColors = getSVGwithColors;
////////////////
function getFinalTransform(transforms) {
    var _a;
    return {
        scaleIsZoom: (_a = transforms[0].scaleIsZoom) !== null && _a !== void 0 ? _a : true,
        scaleX: getMulValue('scaleX', transforms, 1),
        scaleY: getMulValue('scaleY', transforms, 1),
        translateX: getSumValue('translateX', transforms, 0),
        translateY: getSumValue('translateY', transforms, 0),
        rotateZ: getSumValue('rotateZ', transforms, 0),
        opacity: Math.min.apply(null, transforms.map(t => t.opacity)),
    };
}
exports.getFinalTransform = getFinalTransform;
function getSumValue(name, a, initialValue) {
    return a.filter(item => typeof item !== 'undefined').reduce((result, current) => result + (current[name] || 0), initialValue);
}
function getMulValue(name, a, initialValue) {
    return a.filter(item => typeof item !== 'undefined').reduce((result, current) => result * (current[name] || 1), initialValue);
}
